const IS_SERVER_LOCAL = false;
let serverUrl = '';
if (IS_SERVER_LOCAL) {
    serverUrl = 'http://localhost:3333';
}
else {
    serverUrl = 'https://appv2-analytics-server.robotical.io';
}
export const SERVER_URL = serverUrl;
